import SaleTable from '../../sales/saleTable/SaleTable.vue';
import AutocompleteField from '../../../components/inputs/FilterableSelect.vue';

/** Регистрация установленного оборудования покупателем (Гарантии) */
export default {
  name: 'AddGuarantee',
  components: { AutocompleteField, SaleTable },
  props: ['id'],

  data() {
    return {
      /** Регистрируемое оборудование */
      equipment: {
        // Дата покупки
        date_purchase: null,
        // Серийный номер изделия
        serial_number: null,
        // Наименование изделия
        name: null,
        // Дата установки
        date_installation: null,
        // Город установки
        city_id: null,
        city_name: null,
        // Адрес установки
        address: null,
        // Компания-установщик
        installation_company: null,
        // ФИО монтажника
        installation_profile_id: null,
      },
      /** Валидация формы */
      valid: false,
      /** Правила для заполнения формы */
      rules: {
        required: v => !!v || 'Поле должно быть заполнено',
      },
      /** Города */
      cities: [],
      address_data: [],
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    'equipment.serial_number': function (value) {
      this.loadSerialNumbers(value);
    },
    // eslint-disable-next-line func-names
    'equipment.address': function (value) {
      const fl = this.address_data.filter(item => item.value === value);
      this.equipment.city_name = fl[0] && fl[0].data && fl[0].data.city ? fl[0].data.city : '';
    },
  },
  methods: {
    /** Отправить на проверку */
    send() {
      this.$store.getters.ax
        .post('guaranties/api/guaranties/create', {
          ...this.equipment,
          profile_id: this.user.profile_id,
        }).then(() => {
          this.$router.push('/dashboard');
        })
        .catch((error) => {
          this.$store.dispatch('HandleError', error);
        });
    },
    /**
     * Загрузить список городов
     * @param pattern шаблон, введённый пользователем
     */
    loadCities(pattern) {
      return new Promise((resolve) => {
        this.$store.getters.ax
          .post('/profiles/api/location/cities', {
            term: pattern,
            profile_id: this.user.profile_id,
          })
          .then((response) => {
            resolve(response.data.cities);
          });
      });
    },
    /**
     * Загрузить список адресов
     * @param pattern шаблон, введённый пользователем
     */
    loadAddresses(pattern) {
      return new Promise((resolve) => {
        this.$store.getters.ax
          .post('profiles/api/location/addresses', {
            term: pattern,
            city_id: null,
            profile_id: this.user.profile_id,
          })
          .then((response) => {
            this.address_data = response.data.data;
            resolve(response.data.data);
          });
      });
    },
    /**
     * Загрузить список монтажников
     * @param pattern шаблон, введённый пользователем
     */
    loadInstallers(pattern) {
      return new Promise((resolve) => {
        this.$store.getters.ax
          .post('guaranties/api/guaranties/get-installation-user', {
            term: pattern,
          })
          .then((response) => {
            resolve(response.data.profiles);
          });
      });
    },
    /** Загрузить список продукции по серийному номеру */
    loadSerialNumbers(pattern) {
      this.$store.getters.ax
        .post('/guaranties/api/guaranties/from-barcode', {
          term: pattern,
        })
        .then((response) => {
          this.equipment.name = response.data.data.name;
        })
        .catch((error) => {
          this.$store.dispatch('HandleError', error);
          this.equipment.name = null;
        });
    },
  },
};
